export const SERVICE_GET_REQUEST = 'SERVICE_GET_REQUEST';
export const SERVICE_GET_SUCCESS = 'SERVICE_GET_SUCCESS';
export const SERVICE_GET_ERROR = 'SERVICE_GET_ERROR';
export const SERVICE_GET_BY_KEY_REQUEST = 'SERVICE_GET_BY_KEY_REQUEST';
export const SERVICE_GET_BY_KEY_SUCCESS = 'SERVICE_GET_BY_KEY_SUCCESS';
export const SERVICE_GET_BY_KEY_ERROR = 'SERVICE_GET_BY_KEY_ERROR';
export const SERVICE_ADD_REQUEST = 'SERVICE_ADD_REQUEST';
export const SERVICE_ADD_SUCCESS = 'SERVICE_ADD_SUCCESS';
export const SERVICE_ADD_ERROR = 'SERVICE_ADD_ERROR';
export const SERVICE_EDIT_REQUEST = 'SERVICE_EDIT_REQUEST';
export const SERVICE_EDIT_SUCCESS = 'SERVICE_EDIT_SUCCESS';
export const SERVICE_EDIT_ERROR = 'SERVICE_EDIT_ERROR';
export const SERVICE_DELETE_REQUEST = 'SERVICE_DELETE_REQUEST';
export const SERVICE_DELETE_SUCCESS = 'SERVICE_DELETE_SUCCESS';
export const SERVICE_DELETE_ERROR = 'SERVICE_DELETE_ERROR';

export const SERVICE_GET_CHILDS_REQUEST = 'SERVICE_GET_CHILDS_REQUEST';
export const SERVICE_GET_CHILDS_SUCCESS = 'SERVICE_GET_CHILDS_SUCCESS';
export const SERVICE_GET_CHILDS_ERROR = 'SERVICE_GET_CHILDS_ERROR';